import { disableHubSpot } from '@/lib/analytics/hubspot/client';
import { useConsentHandler } from '@/lib/consent';

/**
 * Registers HubSpot's consent teardown. Mounted globally (not in the form) because HubSpot's cookies are domain-wide and withdrawal happens from the cookie-policy page, where the form — and any handler it owned — would be unmounted.
 */
const HubSpotConsent = () => {
  useConsentHandler('hubspot', ({ allowed }) => {
    if (!allowed) {
      disableHubSpot();
    }
  });

  return null;
};

export default HubSpotConsent;
